/* eslint-disable import/no-anonymous-default-export */
export default (
  impaired = { success: null, error: null, data: [] },
  action
) => {
  switch (action.type) {
    case "ALL_IMPAIRED_INVESTMENT":
      return { ...impaired, data: action.payload };
    case "IMPAIR_INVESTMENT":
      const newData = Array.isArray(impaired.data)
        ? [...impaired.data, action.payload]
        : [action.payload];
      return { ...impaired, data: newData };
    case "IMPAIR_INVESTMENT_SUCCESS":
      return { ...impaired, success: action.payload, error: null };
    case "IMPAIR_INVESTMENT_ERROR":
      return { ...impaired, success: null, error: action.payload };
    default:
      return impaired;
  }
};
